(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8313],{

/***/ 45348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function Header(params) {
  var title = params.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "bg-[#231C5E] text-white px-12 pb-6 space-y-2",
    style: {
      backgroundColor: "#22242C"
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h2", {
      children: title
    })
  });
}

/***/ }),

/***/ 65509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ press; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./data/press/items.json
var items = __webpack_require__(48379);
// EXTERNAL MODULE: ./components/landing/Container.jsx + 1 modules
var Container = __webpack_require__(94964);
// EXTERNAL MODULE: ./components/landing/Head.jsx
var Head = __webpack_require__(81519);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 32 modules
var format = __webpack_require__(13524);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Card.jsx






var Card = function Card(_ref) {
  var heading = _ref.heading,
      date = _ref.date,
      desc = _ref.desc,
      author = _ref.author,
      img = _ref.img,
      link = _ref.link,
      linkSource = _ref.linkSource;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
    className: "cursor-pointer",
    href: link,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "w-full h-full rounded-md shadow-md overflow-hidden flex flex-col space-y-2 bg-white text-black",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full relative overflow-hidden h-[220px]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          className: "resposive-image",
          layout: "fill",
          objectFit: "cover",
          src: img
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col flex-1 p-4 space-y-1 justify-between",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-col space-y-1",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
            className: "text-md",
            children: heading
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-xs text-gray-50",
            children: [author, " - ", (0,format/* default */.Z)(new Date(date), "MMMM dd, yyyy")]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-xs text-gray-50",
          children: desc
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "pt-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: link,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "text-primary text-xs",
              children: linkSource
            })
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var components_Card = (Card);
// EXTERNAL MODULE: ./components/aboutus/Header.jsx
var Header = __webpack_require__(45348);
// EXTERNAL MODULE: ./data/seo.json
var seo = __webpack_require__(35546);
// EXTERNAL MODULE: ./components/landing/ContactUsForm.jsx
var ContactUsForm = __webpack_require__(60650);
;// CONCATENATED MODULE: ./pages/press/index.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var Press = function Press() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* default */.Z, {
      SEO: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {
        title: "The Data Mynt Press"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "p-12 space-y-8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
          className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
          children: items.map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(components_Card, _objectSpread({}, _objectSpread(_objectSpread({}, item), {}, {
              link: "/press/".concat(item["name"]),
              linkSource: "Read more"
            })), item["name"]);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-wrapper py-12",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactUsForm/* default */.Z, {})
      })]
    })]
  });
};

/* harmony default export */ var press = (Press);

/***/ }),

/***/ 41795:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/press",
      function () {
        return __webpack_require__(65509);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48379:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"name":"datamynt-alibaba","date":"November 9, 2022","author":"DataMynt Team","heading":"Data Mynt and Alibaba Cloud Announce Partnership to Accelerate Crypto and Cloud Adoption in Africa and Latin America","img":"/datamynt-alibaba.png","desc":"The partnership includes three parts: first, enabling Alibaba Cloud customers to pay for their Cloud services using Data Mynt’s crypto as currency option; second, listing and selling Data Mynt services to Cloud customers on Alibaba [...]","link":"https://www.datamynt.com/press/datamynt-alibaba","linkSource":"DataMynt"},{"name":"datamynt-customers","date":"November 1, 2022","author":"DataMynt Team","heading":"Data Mynt’s Announces Its 500th Business Customer is Accepting and Sending Crypto as Currency","img":"/datamynt-customers.png","desc":"Since launching its crypto as currency solutions for businesses, Data Mynt has enabled its 500th customer, an IHG (Intercontinental Hotels Group) property in Mexico City, to accept payments from millions of crypto customers and [...]","link":"https://www.datamynt.com/press/datamynt-customers","linkSource":"DataMynt"},{"name":"datamynt-yellowcard","date":"September 27, 2022","author":"DataMynt Team","heading":"Data Mynt Partners with Yellow Card Financial to Enable Cash Payouts and Digital Asset Services for Merchants Across Africa","img":"/datamynt-yellowcard.png","desc":"Data Mynt’s strategic partnership with Yellow Card Financial allows merchants and platforms across Africa to accept and send payments in digital assets in person and online, settle immediately, and now withdraw funds directly [...]","link":"https://www.datamynt.com/press/datamynt-yellowcard","linkSource":"DataMynt"},{"name":"datamynt-solana","date":"September 2, 2022","author":"DataMynt Team","heading":"Data Mynt’s Digital Asset Payment and Checkout Solution is Live for the Solana Ecosystem (SOL)","img":"/datamynt-solana.png","desc":"Data Mynt’s integration of the Solana Blockchain (SOL) will allow millions of SOL holders to use Solana for cryptocurrency payments around the world at any Data Mynt merchant location [...]","link":"https://www.datamynt.com/press/datamynt-solana","linkSource":"DataMynt"},{"name":"datamynt-airtm","date":"August 25, 2022","author":"DataMynt Team","heading":"Data Mynt Partners with Airtm to Enable Cash Payouts for Merchants and Platforms Across Latin America","img":"/datamynt-airtm.png","desc":"Data Mynt’s strategic partnership with Airtm allows Data Mynt sellers and platforms across Latin America to accept payments in digital assets in person and online, settle immediately, and now withdraw funds directly into their Airtm [...]","link":"https://www.datamynt.com/press/datamynt-airtm","linkSource":"DataMynt"},{"name":"datamynt-mpos","date":"June 29, 2022","author":"DataMynt Team","heading":"Data Mynt Stable Crypto Mobile Point of Sale (mPOS) Android App Live & Available for Download on Google Play Store","img":"/datamynt-ios.png","desc":"Merchants may now download and use Data Mynt’s Stable Crypto Mobile Point of Sale (mPOS) Android App on Google Play Store today to get paid by their customers instantly for higher margins; higher order values; and attracting new customers [...]","link":"https://www.datamynt.com/press/datamynt-mpos","linkSource":"DataMynt"},{"name":"datamynt-polygon","date":"June 29, 2022","author":"DataMynt Team","heading":"Polygon Makes Strategic Investment in Stable Cryptocurrency Checkout & Payment Protocol Data Mynt","img":"/datamxpolygon.png","desc":"The investment & integration streamlines adoption of Data Mynt’s stable crypto checkout and payment protocol globally on the Polygon network for merchants and metaverse builders alike [...]","link":"https://www.datamynt.com/press/datamynt-polygon","linkSource":"DataMynt"},{"name":"datamynt-ios","date":"June 15, 2022","author":"DataMynt Team","heading":"Data Mynt Launches Stable Crypto Mobile Point of Sale for North American Merchants on Apple iOS","img":"/datamynt-ios.png","desc":"Merchants in North America can now download Data Mynt’s Crypto Mobile Point of Sale (mPOS) to get paid by their crypto customers instantly with no volatility, no declines, and 80% less costs versus card payments [...]","link":"https://www.datamynt.com/press/datamynt-ios","linkSource":"DataMynt"},{"name":"datamynt-binance","date":"June 07, 2022","author":"DataMynt Team","heading":"Data Mynt Stable, Omni-Chain Merchant Payment Checkout Solution is Live on Binance Chain (BNB)","img":"/datamynt-binance.png","desc":"Data Mynt’s integration of Binance Chain (BNB), formerly Binance Smart Chain (BSC) in addition to enabling BNB and BUSD coins allows all owners of BNB-enabled wallets [...]","link":"https://www.datamynt.com/press/datamynt-binance","linkSource":"DataMynt"},{"name":"lightning-network","date":"April 11, 2022","author":"DataMynt Team","heading":"Data Mynt Crypto Payment Processing Gateway Now Live On Bitcoin Lightning Network","img":"/dm_ln.png","link":"https://www.datamynt.com/press/lightning-network","desc":"Lightning Network now gives Data Mynt merchants, partners and their customers a faster option for Bitcoin transactions at minimal cost."},{"name":"presswire-bitcoin","date":"April 5, 2022","author":"DataMynt Team","heading":"Data Mynt Payment Processing Platform Now Supports Bitcoin Payments","img":"/datamyntxbitcoin.jpg","desc":"Data Mynt merchants, partners and their customers can now engage in transactions using the world’s first and best-known decentralized digital currency. [...]","link":"https://www.einnews.com/pr_news/567535868/data-mynt-payment-processing-platform-now-supports-bitcoin-payments","linkSource":"EIN Presswire"},{"name":"presswire-polygon","date":"March 17, 2022","author":"DataMynt Team","heading":"The Data Mynt Crypto Payment Processing Platform is Live on the Polygon Network","img":"/datamxpolygon.png","desc":"Data Mynt integration with Polygon enables Ethereum scaling and rapid blockchain payments for merchants, partners and their consumers. [...]","link":"https://www.einpresswire.com/article/565770248/the-data-mynt-crypto-payment-processing-platform-is-live-on-the-polygon-network","linkSource":"EIN Presswire"},{"name":"presswire","date":"March 10, 2022","author":"DataMynt Team","heading":"New Data Mynt Crypto Payment Processing Platform Gives Merchants Simple, Stable Crypto Payments","img":"/payment.jpg","desc":"Retailers and enterprises now have a simple, stable way to adopt crypto payments using the new crypto payment processing solution from Data Mynt, a recognized provider of cryptocurrency payment products [...]","link":"https://www.einpresswire.com/article/565125848/new-data-mynt-crypto-payment-processing-platform-gives-merchants-simple-stable-crypto-payments?r=padmysCPPxBIz9Qt3k","linkSource":"EIN Presswire"}]');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,906,7258,5675,2580,6770,646,9530,2834,7965,4964,169,9774,2888,179], function() { return __webpack_exec__(41795); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);